export const formatValueDiligence = (authItem) => {
  const variant = {
    "1": true,
    "0": false,
    "null": false,
  };

  return variant[authItem];
}